import { useState } from "react"
import styled from "styled-components"
import { colors } from "utils"
import { SpeechBubble } from "../SpeechBubble/SpeechBubble"

const defaultText = `These session summaries are in BETA as they are generated by our ever-improving AI and may contain inaccuracies. Use it as a helpful guide to supplement your expert observations`

export const BetaTag = ({ text = defaultText }) => {
  const [hover, setHover] = useState(false)

  return (
    <Container onMouseOver={() => setHover(true)} onMouseOut={() => setHover(false)}>
      <Tag>
        BETA
      </Tag>
      {hover && (
        <SpeechBubble text={text} positionLeft={90} positionBottom={-65} minWidth={400} isCustom />
      )}
    </Container>
  )
}

const Container = styled.div`
  position: relative;
`

const Tag = styled.span`
  background-color: ${colors.pink700};
  color: white;
  height: 23px;
  width: 64px;
  border-radius: 200px;
  font-size: 12px;
  font-weight: 800;
  padding: 4px 16px;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`
